import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ADMIN_API } from "../../common/common";
import { Logout } from "../../common/Funcation";
import Loader from "../../components/Loader";
import { postApi, notifyError } from "../../service";
import moment from "moment";

function ProviderPL() {
  const [startDate, setStartDate] = useState(() => {
    const d = new Date();
    d.setDate(d.getDate() - 1);
    return d;
  });
  const [endDate, setEndDate] = useState(new Date());
  const [type, setType] = useState("All");
  const [isLoader, setIsLoader] = useState(false);
  const [pageData, setPageData] = useState<any>({});

  const navigate = useNavigate();

  useEffect(() => {
    getPageData();
  }, []);

  const getPageData = async (FROM: string = "", TO: string = "") => {
    setIsLoader(true);
    let fromDate = FROM;
    let toDate = TO;

    if (!fromDate) {
      fromDate = `${moment(startDate).format("YYYY-MM-DD")}T00:00:00.000Z`;
    }
    if (!toDate) {
      toDate = `${moment(endDate).format("YYYY-MM-DD")}T23:59:59.000Z`;
    }

    let data: any = {
      api: ADMIN_API.REPORT.SHOW_PROVIDER_PL,
      value: {
        from: fromDate,
        to: toDate,
        type: type,
      },
    };

    await postApi(data)
      .then(function (response) {
        setPageData(response?.data?.data || {});
        setIsLoader(false);
      })
      .catch((err) => {
        setIsLoader(false);
        if (err?.response?.data?.statusCode === 401) {
          Logout();
          navigate("/login");
        }
      });
  };

  const handleGetPnL = () => {
    // Add time to dates for validation
    const startDateTime = moment(startDate).set({ hour: 0, minute: 0, second: 0 });
    const endDateTime = moment(endDate).set({ hour: 23, minute: 59, second: 59 });

    // Validate date range
    const daysDiff = moment(endDate).diff(moment(startDate), 'days');

    if (daysDiff > 31) {
      notifyError("Date range cannot exceed 31 days");
      return;
    }

    // Validate full datetime (date + time)
    if (startDateTime.isAfter(endDateTime)) {
      notifyError("Start date/time cannot be after end date/time");
      return;
    }

    if (startDateTime.isSame(endDateTime)) {
      notifyError("Start date/time cannot be the same as end date/time");
      return;
    }

    const from = `${moment(startDate).format("YYYY-MM-DD")}T00:00:00.000Z`;
    const to = `${moment(endDate).format("YYYY-MM-DD")}T23:59:59.000Z`;
    getPageData(from, to);
  };

  const dataList = pageData?.list || pageData?.userList || [];

  const pageTotal = dataList.reduce((acc: number, item: any) => {
    return acc + Number(item.pl || item.profit || 0);
  }, 0);

  return (
    <div
      style={{
        padding: "10px 15px",
        width: "100%",
        background: "#F0ECE1",
        minHeight: "100vh",
      }}
    >
      {/* Title */}
      <h3
        style={{
          color: "red",
          fontWeight: "bold",
          fontSize: "17px",
          marginBottom: "10px",
        }}
      >
        Provider PL - Green Amount Means Company is in Plus
      </h3>

      <section className="my-account-section" style={{ marginBottom: "10px" }}>
        <div
          className="function-wrap"
          style={{
            display: "block",
            background: "transparent",
            borderBottom: "none",
            border: "none",
          }}
        >
          <ul
            className="input-list"
            style={{
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "10px",
            }}
          >
            <li style={{ display: "flex", alignItems: "center" }}>
              <label>Type &nbsp;</label>
              <select
                style={{ margin: "0" }}
                value={type}
                onChange={(e) => setType(e.target.value)}
              >
                <option value="All">All</option>
                <option value="LIVE">LIVE</option>
                <option value="SLOT">SLOT</option>
                <option value="TABLE">TABLE</option>
                <option value="EGAME">EGAME</option>
                <option value="FISH">FISH</option>
              </select>
            </li>

            <li style={{ display: "flex", alignItems: "center" }}>
              <label>Period &nbsp;</label>
              <input
                id="startDate"
                className="cal-input"
                type="date"
                value={`${moment(startDate).format("YYYY-MM-DD")}`}
                placeholder="YYYY-MM-DD"
                onChange={(e: any) => {
                  const newDate = new Date(e?.target?.value);
                  setStartDate(newDate);
                }}
              />
              &nbsp; to &nbsp;
              <input
                id="endDate"
                className="cal-input"
                type="date"
                value={`${moment(endDate).format("YYYY-MM-DD")}`}
                placeholder="YYYY-MM-DD"
                onChange={(e: any) => {
                  const newDate = new Date(e?.target?.value);
                  setEndDate(newDate);
                }}
              />
            </li>

            <li>
              <a
                id="getPL"
                className="btn-send"
                style={{
                  backgroundColor: "#FFB80C",
                  color: "#000",
                  border: "1px solid #000",
                  cursor: "pointer",
                }}
                onClick={() => handleGetPnL()}
              >
                Get P &amp; L
              </a>
            </li>
          </ul>
        </div>
      </section>

      {/* Page Total Banner */}
      <div
        style={{
          background: "#e0e0e0",
          padding: "4px 12px",
          borderTop: "1px solid #7e97a7",
          borderBottom: "1px solid #7e97a7",
          marginBottom: "25px",
          fontSize: "20px",
          fontWeight: "bold",
          color: "#333",
          lineHeight: "20px"
        }}
      >
        Page Total -:{" "}
        <span style={{ color: "#008000", fontWeight: "bold" }}>
          {pageTotal.toFixed(2)}
        </span>
      </div>

      {/* Table */}
      <div className="my-account-section-content" style={{ overflowX: "auto" }}>
        <div className="my-account-section-content-table">
          {isLoader && <Loader />}
          <table
            id="resultTable"
            className="table01 margin-table"
            style={{ width: "100%" }}
          >
            <thead>
              <tr style={{ background: "#d9d9d9" }}>
                <th className="light-grey-bg" style={{ width: "25%" }}>S No</th>
                <th className="light-grey-bg">Company</th>
                <th className="light-grey-bg">Provider</th>
                <th className="light-grey-bg">Type</th>
                <th className="light-grey-bg">PL</th>
                <th className="light-grey-bg align-C">Action</th>
              </tr>
            </thead>
            {!isLoader && dataList && dataList.length > 0 && (
              <>
                <tbody>
                  {dataList.map((item: any, i: number) => {
                    const plValue = Number(item.pl || item.profit || 0);
                    return (
                      <tr key={item._id || i}>
                        <td style={{ width: "25%" }}>{i + 1}</td>
                        <td>{item.company || item.website || "AWC"}</td>
                        <td>
                          {item.provider || item.providerName || item.name || "-"}
                        </td>
                        <td>{item.type || item.gameType || "LIVE"}</td>
                        <td
                          style={{
                            fontWeight: "bold",
                            color: plValue >= 0 ? "#008000" : "red",
                          }}
                        >
                          {plValue.toFixed(2)}
                        </td>
                        <td className="align-C">
                          <a
                            className="btn-send"
                            style={{
                              backgroundColor: "#FFB80C",
                              color: "#000",
                              border: "1px solid #000",
                              padding: "2px 8px",
                              fontSize: "11px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              /* Action handler */
                            }}
                          >
                            Get Details
                          </a>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
                <tfoot>
                  <style>{`
                    .table01 tfoot th {
                      border-top: 1px solid #7e97a7 !important;
                      border-bottom: 1px solid #fff !important;
                      background: transparent;
                    }
                  `}</style>
                  <tr>
                    <th className="border-top"></th>
                    <th className="border-top"></th>
                    <th className="border-top"></th>
                    <th className="border-top"><strong>Total</strong></th>
                    <th
                      className="border-top"
                      style={{
                        fontWeight: "bold",
                        color: pageTotal >= 0 ? "#008000" : "red",
                      }}
                    >
                      {pageTotal.toFixed(2)}
                    </th>
                    <th className="border-top"></th>
                  </tr>
                </tfoot>
              </>
            )}
          </table>
        </div>
      </div>
    </div>
  );
}

export default ProviderPL;
